document.addEventListener('DOMContentLoaded', function() {
  initProductCarousel();
  initCartAjax();
  initContactForm();
  initCurrencyConverter();
  initStickyHeader();
  initLuxuryLoader();
});

// 1. Product Carousel functionality
function initProductCarousel() {
  const track = document.querySelector('.product-slider-track');
  if (!track) return;

  const slides = Array.from(track.children);
  const nextBtn = document.querySelector('.slider-arrow-btn--next');
  const prevBtn = document.querySelector('.slider-arrow-btn--prev');
  const dotsNav = document.querySelector('.slider-pagination-dots');
  if (!dotsNav) return;
  
  const dots = Array.from(dotsNav.children);

  let currentIndex = 0;
  
  // Calculate how many visible items we have based on screen width
  function getVisibleSlidesCount() {
    if (window.innerWidth >= 1024) return 2; // Split screen: spotlight takes 50%, shows 2 slides inside its column
    if (window.innerWidth >= 480) return 2;  // Standard tablet: 2 slides
    return 1; // Mobile: 1 slide
  }

  function updateSlider() {
    const visibleCount = getVisibleSlidesCount();
    const maxIndex = Math.max(0, slides.length - visibleCount);
    
    if (currentIndex > maxIndex) {
      currentIndex = maxIndex;
    }
    
    // Calculate transition offset
    const slideWidth = slides[0].getBoundingClientRect().width;
    const gap = 16; // 1rem in pixels
    const offset = currentIndex * (slideWidth + gap);
    
    track.style.transform = `translateX(-${offset}px)`;
    
    // Update dots
    dots.forEach((dot, index) => {
      if (index === currentIndex) {
        dot.classList.add('is-active');
      } else {
        dot.classList.remove('is-active');
      }
    });

    // Disable arrows if boundary reached
    if (prevBtn) prevBtn.style.opacity = currentIndex === 0 ? '0.4' : '1';
    if (nextBtn) nextBtn.style.opacity = currentIndex === maxIndex ? '0.4' : '1';
  }

  // Set initial state
  updateSlider();
  window.addEventListener('resize', updateSlider);

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      const visibleCount = getVisibleSlidesCount();
      const maxIndex = slides.length - visibleCount;
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateSlider();
      }
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      if (currentIndex > 0) {
        currentIndex--;
        updateSlider();
      }
    });
  }

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      currentIndex = index;
      updateSlider();
    });
  });
}

// 2. Real Ajax Cart update
function initCartAjax() {
  const updateButtonText = (btn, text) => {
    if (btn.tagName === 'INPUT') {
      btn.value = text;
    } else {
      btn.textContent = text;
    }
  };

  const getButtonText = (btn) => {
    return btn.tagName === 'INPUT' ? btn.value : btn.textContent;
  };

  // Helper to handle live Ajax cart additions
  const submitCartAjaxForm = (form, submitBtn) => {
    const originalText = getButtonText(submitBtn) || 'Add To Cart';
    const isBuyNow = submitBtn && (submitBtn.getAttribute('name') === 'checkout' || submitBtn.dataset.buyNow === 'true' || originalText.toLowerCase().includes('buy it now'));
    
    // Visual feedback: set button state
    if (!isBuyNow) {
      updateButtonText(submitBtn, 'ADDING...');
    }
    submitBtn.disabled = true;
    const originalBg = submitBtn.style.backgroundColor;
    const originalColor = submitBtn.style.color;
    if (!isBuyNow) {
      submitBtn.style.backgroundColor = '#C4A468';
      submitBtn.style.color = '#0C1E36';
    }

    // 1. Instant responsive feedback: update badge count locally
    const qtyInput = form.querySelector('[name="quantity"]');
    const addedQty = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;
    
    let expectedCount = 0;
    const cartBadges = document.querySelectorAll('.cart-badge-counter');
    cartBadges.forEach(badge => {
      let currentCount = parseInt(badge.textContent.trim()) || 0;
      expectedCount = Math.max(expectedCount, currentCount + addedQty);
      badge.textContent = expectedCount;
      badge.style.display = 'flex';
      
      // Micro-animation: bounce effect
      badge.style.transform = 'scale(1.4)';
      badge.style.transition = 'transform 0.2s ease';
      setTimeout(() => {
        badge.style.transform = 'scale(1)';
      }, 200);
    });

    // 2. Perform background request to Shopify Ajax API
    const formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to add item to cart');
      }
      return response.json();
    })
    .then(item => {
      if (isBuyNow) {
        window.location.href = '/checkout';
        return;
      }
      // Wait 500ms to allow Shopify session database to sync, then fetch full cart details
      return new Promise(resolve => setTimeout(resolve, 500))
        .then(() => fetch('/cart.js?t=' + Date.now()));
    })
    .then(response => {
      if (isBuyNow || !response) return;
      return response.json();
    })
    .then(cart => {
      if (isBuyNow || !cart) return;
      // Sync badge count with server (only if it matches or exceeds our expected count)
      if (cart.item_count >= expectedCount) {
        cartBadges.forEach(badge => {
          badge.textContent = cart.item_count;
        });
      }

      // Set button to success state
      updateButtonText(submitBtn, 'ADDED');
      setTimeout(() => {
        updateButtonText(submitBtn, originalText);
        submitBtn.disabled = false;
        submitBtn.style.backgroundColor = originalBg;
        submitBtn.style.color = originalColor;
      }, 1000);
    })
    .catch(error => {
      console.error('Cart Ajax Error:', error);
      // Roll back the optimistic badge update and tell the user it failed.
      fetch('/cart.js?t=' + Date.now())
        .then(res => res.json())
        .then(cart => {
          cartBadges.forEach(badge => {
            badge.textContent = cart.item_count;
            badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
          });
        })
        .catch(() => {});
      updateButtonText(submitBtn, 'ERROR - TRY AGAIN');
      setTimeout(() => {
        updateButtonText(submitBtn, originalText);
        submitBtn.disabled = false;
        submitBtn.style.backgroundColor = originalBg;
        submitBtn.style.color = originalColor;
      }, 2000);
    });
  };

  // Helper to handle mock/placeholder product card additions
  const handleMockCartAddition = (button) => {
    const originalText = getButtonText(button) || 'Quick Buy';
    
    // Visual feedback
    updateButtonText(button, 'ADDING...');
    button.disabled = true;
    const originalBg = button.style.backgroundColor;
    const originalColor = button.style.color;
    button.style.backgroundColor = '#C4A468';
    button.style.color = '#0C1E36';

    setTimeout(() => {
      // Increment locally
      const cartBadges = document.querySelectorAll('.cart-badge-counter');
      cartBadges.forEach(badge => {
        let currentCount = parseInt(badge.textContent.trim()) || 0;
        badge.textContent = currentCount + 1;
        badge.style.display = 'flex';
        
        // Micro-animation
        badge.style.transform = 'scale(1.4)';
        badge.style.transition = 'transform 0.2s ease';
        setTimeout(() => {
          badge.style.transform = 'scale(1)';
        }, 200);
      });

      updateButtonText(button, 'ADDED');
      setTimeout(() => {
        updateButtonText(button, originalText);
        button.disabled = false;
        button.style.backgroundColor = originalBg;
        button.style.color = originalColor;
      }, 1000);
    }, 600);
  };

  // Intercept click events directly to guarantee immediate blocking of default browser submission
  document.addEventListener('click', function(e) {
    const button = e.target.closest('.product-card-btn') || e.target.closest('[type="submit"]') || e.target.closest('.btn--gold');
    if (!button) return;

    const form = button.closest('form');
    if (form) {
      const action = form.getAttribute('action') || '';
      if (action.includes('/cart/add') || (form.action && form.action.includes('/cart/add'))) {
        e.preventDefault();
        e.stopPropagation();
        submitCartAjaxForm(form, button);
      }
    } else if (button.classList.contains('product-card-btn')) {
      e.preventDefault();
      e.stopPropagation();
      handleMockCartAddition(button);
    }
  });

  // Handle global cart updates (e.g. from featured products grid custom elements)
  document.addEventListener('cart:updated', function(e) {
    const cart = e.detail.cart;
    if (!cart) return;
    const cartBadges = document.querySelectorAll('.cart-badge-counter');
    cartBadges.forEach(badge => {
      badge.textContent = cart.item_count;
      badge.style.display = 'flex';
      
      // Micro-animation: bounce effect
      badge.style.transform = 'scale(1.4)';
      badge.style.transition = 'transform 0.2s ease';
      setTimeout(() => {
        badge.style.transform = 'scale(1)';
      }, 200);
    });
  });
}

// 3. Contact Form Submission feedback
function initContactForm() {
  const form = document.querySelector('.contact-form');
  if (!form) return;

  // Let's add a dynamic mock submission message to override standard behavior if needed, 
  // or allow Shopify's native form submission to work, but add styling details.
  form.addEventListener('submit', function(e) {
    const isMock = form.getAttribute('action') === '#' || !form.getAttribute('action');
    if (isMock) {
      e.preventDefault();
      
      const submitBtn = form.querySelector('.contact-submit-btn');
      if (submitBtn) {
        submitBtn.value = 'SENDING...';
        submitBtn.disabled = true;
      }

      setTimeout(() => {
        // Create success banner
        const container = form.parentElement;
        form.style.display = 'none';
        
        const successBanner = document.createElement('div');
        successBanner.className = 'form-success-banner font-serif';
        successBanner.innerHTML = `
          <h3 style="margin-bottom: 0.5rem; color: #C4A468; text-transform: uppercase;">THANK YOU FOR YOUR CURIOSITY</h3>
          <p style="font-family: 'Inter', sans-serif; font-size: 0.9rem;">We have received your message and our curatorial team will be in touch shortly.</p>
        `;
        container.appendChild(successBanner);
      }, 1000);
    }
  });
}

// 4. Display-only currency converter.
// The store checks out in its base currency (window.themeStoreCurrency, set in
// layout/theme.liquid). Prices on the storefront are converted for display per
// the visitor's selected region; the cart shows a disclosure bar with the
// actual charge currency so displayed and charged amounts are never confused.
function initCurrencyConverter() {
  const BASE = (window.themeStoreCurrency || 'USD').toUpperCase();

  const countryToCurrency = {
    "IN": { code: "INR", symbol: "₹", name: "India" },
    "US": { code: "USD", symbol: "$", name: "United States" },
    "GB": { code: "GBP", symbol: "£", name: "United Kingdom" },
    "EU": { code: "EUR", symbol: "€", name: "European Union" },
    "AF": { code: "AFN", symbol: "؋", name: "Afghanistan" },
    "AX": { code: "EUR", symbol: "€", name: "Åland Islands" },
    "AL": { code: "ALL", symbol: "L", name: "Albania" },
    "DZ": { code: "DZD", symbol: "د.ج", name: "Algeria" },
    "AD": { code: "EUR", symbol: "€", name: "Andorra" },
    "AO": { code: "AOA", symbol: "Kz", name: "Angola" },
    "AI": { code: "XCD", symbol: "$", name: "Anguilla" },
    "AG": { code: "XCD", symbol: "$", name: "Antigua & Barbuda" },
    "AR": { code: "ARS", symbol: "$", name: "Argentina" },
    "AM": { code: "AMD", symbol: "֏", name: "Armenia" },
    "AW": { code: "AWG", symbol: "ƒ", name: "Aruba" },
    "AC": { code: "SHP", symbol: "£", name: "Ascension Island" },
    "AU": { code: "AUD", symbol: "$", name: "Australia" },
    "AT": { code: "EUR", symbol: "€", name: "Austria" },
    "AZ": { code: "AZN", symbol: "₼", name: "Azerbaijan" },
    "BS": { code: "BSD", symbol: "$", name: "Bahamas" },
    "BH": { code: "BHD", symbol: ".د.ب", name: "Bahrain" },
    "BD": { code: "BDT", symbol: "৳", name: "Bangladesh" },
    "BB": { code: "BBD", symbol: "$", name: "Barbados" },
    "BY": { code: "BYN", symbol: "Br", name: "Belarus" },
    "BE": { code: "EUR", symbol: "€", name: "Belgium" },
    "BZ": { code: "BZD", symbol: "$", name: "Belize" },
    "BJ": { code: "XOF", symbol: "Fr", name: "Benin" },
    "BM": { code: "BMD", symbol: "$", name: "Bermuda" },
    "BT": { code: "BTN", symbol: "Nu.", name: "Bhutan" },
    "BO": { code: "BOB", symbol: "Bs.", name: "Bolivia" },
    "BA": { code: "BAM", symbol: "KM", name: "Bosnia & Herzegovina" },
    "BW": { code: "BWP", symbol: "P", name: "Botswana" },
    "BR": { code: "BRL", symbol: "R$", name: "Brazil" },
    "IO": { code: "USD", symbol: "$", name: "British Indian Ocean Territory" },
    "VG": { code: "USD", symbol: "$", name: "British Virgin Islands" },
    "BN": { code: "BND", symbol: "$", name: "Brunei" },
    "BG": { code: "BGN", symbol: "лв", name: "Bulgaria" },
    "BF": { code: "XOF", symbol: "Fr", name: "Burkina Faso" },
    "BI": { code: "BIF", symbol: "Fr", name: "Burundi" },
    "KH": { code: "KHR", symbol: "៛", name: "Cambodia" },
    "CM": { code: "XAF", symbol: "Fr", name: "Cameroon" },
    "CA": { code: "CAD", symbol: "$", name: "Canada" },
    "CV": { code: "CVE", symbol: "Esc", name: "Cape Verde" },
    "BQ": { code: "USD", symbol: "$", name: "Caribbean Netherlands" },
    "KY": { code: "KYD", symbol: "$", name: "Cayman Islands" },
    "CF": { code: "XAF", symbol: "Fr", name: "Central African Republic" },
    "TD": { code: "XAF", symbol: "Fr", name: "Chad" },
    "CL": { code: "CLP", symbol: "$", name: "Chile" },
    "CN": { code: "CNY", symbol: "¥", name: "China" },
    "CX": { code: "AUD", symbol: "$", name: "Christmas Island" },
    "CC": { code: "AUD", symbol: "$", name: "Cocos (Keeling) Islands" },
    "CO": { code: "COP", symbol: "$", name: "Colombia" },
    "KM": { code: "KMF", symbol: "Fr", name: "Comoros" },
    "CG": { code: "XAF", symbol: "Fr", name: "Congo - Brazzaville" },
    "CD": { code: "CDF", symbol: "Fr", name: "Congo - Kinshasa" },
    "CK": { code: "NZD", symbol: "$", name: "Cook Islands" },
    "CR": { code: "CRC", symbol: "₡", name: "Costa Rica" },
    "HR": { code: "EUR", symbol: "€", name: "Croatia" },
    "CW": { code: "ANG", symbol: "ƒ", name: "Curaçao" },
    "CY": { code: "EUR", symbol: "€", name: "Cyprus" },
    "CZ": { code: "CZK", symbol: "Kč", name: "Czechia" },
    "CI": { code: "XOF", symbol: "Fr", name: "Côte d’Ivoire" },
    "DK": { code: "DKK", symbol: "kr", name: "Denmark" },
    "DJ": { code: "DJF", symbol: "Fr", name: "Djibouti" },
    "DM": { code: "XCD", symbol: "$", name: "Dominica" },
    "DO": { code: "DOP", symbol: "$", name: "Dominican Republic" },
    "EC": { code: "USD", symbol: "$", name: "Ecuador" },
    "EG": { code: "EGP", symbol: "E£", name: "Egypt" },
    "SV": { code: "USD", symbol: "$", name: "El Salvador" },
    "GQ": { code: "XAF", symbol: "Fr", name: "Equatorial Guinea" },
    "ER": { code: "ERN", symbol: "Nfk", name: "Eritrea" },
    "EE": { code: "EUR", symbol: "€", name: "Estonia" },
    "SZ": { code: "SZL", symbol: "L", name: "Eswatini" },
    "ET": { code: "ETB", symbol: "Br", name: "Ethiopia" },
    "FK": { code: "FKP", symbol: "£", name: "Falkland Islands" },
    "FO": { code: "DKK", symbol: "kr", name: "Faroe Islands" },
    "FJ": { code: "FJD", symbol: "$", name: "Fiji" },
    "FI": { code: "EUR", symbol: "€", name: "Finland" },
    "FR": { code: "EUR", symbol: "€", name: "France" },
    "GF": { code: "EUR", symbol: "€", name: "French Guiana" },
    "PF": { code: "XPF", symbol: "Fr", name: "French Polynesia" },
    "TF": { code: "EUR", symbol: "€", name: "French Southern Territories" },
    "GA": { code: "XAF", symbol: "Fr", name: "Gabon" },
    "GM": { code: "GMD", symbol: "D", name: "Gambia" },
    "GE": { code: "GEL", symbol: "₾", name: "Georgia" },
    "DE": { code: "EUR", symbol: "€", name: "Germany" },
    "GH": { code: "GHS", symbol: "₵", name: "Ghana" },
    "GI": { code: "GIP", symbol: "£", name: "Gibraltar" },
    "GR": { code: "EUR", symbol: "€", name: "Greece" },
    "GL": { code: "DKK", symbol: "kr", name: "Greenland" },
    "GD": { code: "XCD", symbol: "$", name: "Grenada" },
    "GP": { code: "EUR", symbol: "€", name: "Guadeloupe" },
    "GT": { code: "GTQ", symbol: "Q", name: "Guatemala" },
    "GG": { code: "GBP", symbol: "£", name: "Guernsey" },
    "GN": { code: "GNF", symbol: "Fr", name: "Guinea" },
    "GW": { code: "XOF", symbol: "Fr", name: "Guinea-Bissau" },
    "GY": { code: "GYD", symbol: "$", name: "Guyana" },
    "HT": { code: "HTG", symbol: "G", name: "Haiti" },
    "HN": { code: "HNL", symbol: "L", name: "Honduras" },
    "HK": { code: "HKD", symbol: "$", name: "Hong Kong SAR" },
    "HU": { code: "HUF", symbol: "Ft", name: "Hungary" },
    "IS": { code: "ISK", symbol: "kr", name: "Iceland" },
    "ID": { code: "IDR", symbol: "Rp", name: "Indonesia" },
    "IQ": { code: "IQD", symbol: "ع.د", name: "Iraq" },
    "IE": { code: "EUR", symbol: "€", name: "Ireland" },
    "IM": { code: "GBP", symbol: "£", name: "Isle of Man" },
    "IL": { code: "ILS", symbol: "₪", name: "Israel" },
    "IT": { code: "EUR", symbol: "€", name: "Italy" },
    "JM": { code: "JMD", symbol: "$", name: "Jamaica" },
    "JP": { code: "JPY", symbol: "¥", name: "Japan" },
    "JE": { code: "GBP", symbol: "£", name: "Jersey" },
    "JO": { code: "JOD", symbol: "د.ا", name: "Jordan" },
    "KZ": { code: "KZT", symbol: "₸", name: "Kazakhstan" },
    "KE": { code: "KES", symbol: "Sh", name: "Kenya" },
    "KI": { code: "AUD", symbol: "$", name: "Kiribati" },
    "XK": { code: "EUR", symbol: "€", name: "Kosovo" },
    "KW": { code: "KWD", symbol: "د.ك", name: "Kuwait" },
    "KG": { code: "KGS", symbol: "с", name: "Kyrgyzstan" },
    "LA": { code: "LAK", symbol: "₭", name: "Laos" },
    "LV": { code: "EUR", symbol: "€", name: "Latvia" },
    "LB": { code: "LBP", symbol: "ل.ل", name: "Lebanon" },
    "LS": { code: "LSL", symbol: "L", name: "Lesotho" },
    "LR": { code: "LRD", symbol: "$", name: "Liberia" },
    "LY": { code: "LYD", symbol: "ل.د", name: "Libya" },
    "LI": { code: "CHF", symbol: "CHF", name: "Liechtenstein" },
    "LT": { code: "EUR", symbol: "€", name: "Lithuania" },
    "LU": { code: "EUR", symbol: "€", name: "Luxembourg" },
    "MO": { code: "MOP", symbol: "P", name: "Macao SAR" },
    "MG": { code: "MGA", symbol: "Ar", name: "Madagascar" },
    "MW": { code: "MWK", symbol: "MK", name: "Malawi" },
    "MY": { code: "MYR", symbol: "RM", name: "Malaysia" },
    "MV": { code: "MVR", symbol: "Rf", name: "Maldives" },
    "ML": { code: "XOF", symbol: "Fr", name: "Mali" },
    "MT": { code: "EUR", symbol: "€", name: "Malta" },
    "MQ": { code: "EUR", symbol: "€", name: "Martinique" },
    "MR": { code: "MRU", symbol: "UM", name: "Mauritania" },
    "MU": { code: "MUR", symbol: "₨", name: "Mauritius" },
    "YT": { code: "EUR", symbol: "€", name: "Mayotte" },
    "MX": { code: "MXN", symbol: "$", name: "Mexico" },
    "MD": { code: "MDL", symbol: "L", name: "Moldova" },
    "MC": { code: "EUR", symbol: "€", name: "Monaco" },
    "MN": { code: "MNT", symbol: "₮", name: "Mongolia" },
    "ME": { code: "EUR", symbol: "€", name: "Montenegro" },
    "MS": { code: "XCD", symbol: "$", name: "Montserrat" },
    "MA": { code: "MAD", symbol: "د.م.", name: "Morocco" },
    "MZ": { code: "MZN", symbol: "MT", name: "Mozambique" },
    "MM": { code: "MMK", symbol: "K", name: "Myanmar (Burma)" },
    "NA": { code: "NAD", symbol: "$", name: "Namibia" },
    "NR": { code: "AUD", symbol: "$", name: "Nauru" },
    "NP": { code: "NPR", symbol: "₨", name: "Nepal" },
    "NL": { code: "EUR", symbol: "€", name: "Netherlands" },
    "NC": { code: "XPF", symbol: "Fr", name: "New Caledonia" },
    "NZ": { code: "NZD", symbol: "$", name: "New Zealand" },
    "NI": { code: "NIO", symbol: "C$", name: "Nicaragua" },
    "NE": { code: "XOF", symbol: "Fr", name: "Niger" },
    "NG": { code: "NGN", symbol: "₦", name: "Nigeria" },
    "NU": { code: "NZD", symbol: "$", name: "Niue" },
    "NF": { code: "AUD", symbol: "$", name: "Norfolk Island" },
    "MK": { code: "MKD", symbol: "ден", name: "North Macedonia" },
    "NO": { code: "NOK", symbol: "kr", name: "Norway" },
    "OM": { code: "OMR", symbol: "ر.ع.", name: "Oman" },
    "PK": { code: "PKR", symbol: "₨", name: "Pakistan" },
    "PS": { code: "ILS", symbol: "₪", name: "Palestinian Territories" },
    "PA": { code: "USD", symbol: "$", name: "Panama" },
    "PG": { code: "PGK", symbol: "K", name: "Papua New Guinea" },
    "PY": { code: "PYG", symbol: "₲", name: "Paraguay" },
    "PE": { code: "PEN", symbol: "S/.", name: "Peru" },
    "PH": { code: "PHP", symbol: "₱", name: "Philippines" },
    "PN": { code: "NZD", symbol: "$", name: "Pitcairn Islands" },
    "PL": { code: "PLN", symbol: "zł", name: "Poland" },
    "PT": { code: "EUR", symbol: "€", name: "Portugal" },
    "QA": { code: "QAR", symbol: "ر.ق", name: "Qatar" },
    "RE": { code: "EUR", symbol: "€", name: "Réunion" },
    "RO": { code: "RON", symbol: "lei", name: "Romania" },
    "RU": { code: "RUB", symbol: "₽", name: "Russia" },
    "RW": { code: "RWF", symbol: "Fr", name: "Rwanda" },
    "WS": { code: "WST", symbol: "T", name: "Samoa" },
    "SM": { code: "EUR", symbol: "€", name: "San Marino" },
    "ST": { code: "STN", symbol: "Db", name: "São Tomé & Príncipe" },
    "SA": { code: "SAR", symbol: "ر.س", name: "Saudi Arabia" },
    "SN": { code: "XOF", symbol: "Fr", name: "Senegal" },
    "RS": { code: "RSD", symbol: "дин.", name: "Serbia" },
    "SC": { code: "SCR", symbol: "₨", name: "Seychelles" },
    "SL": { code: "SLE", symbol: "Le", name: "Sierra Leone" },
    "SG": { code: "SGD", symbol: "$", name: "Singapore" },
    "SX": { code: "ANG", symbol: "ƒ", name: "Sint Maarten" },
    "SK": { code: "EUR", symbol: "€", name: "Slovakia" },
    "SI": { code: "EUR", symbol: "€", name: "Slovenia" },
    "SB": { code: "SBD", symbol: "$", name: "Solomon Islands" },
    "SO": { code: "SOS", symbol: "Sh", name: "Somalia" },
    "ZA": { code: "ZAR", symbol: "R", name: "South Africa" },
    "GS": { code: "GBP", symbol: "£", name: "South Georgia & South Sandwich Islands" },
    "KR": { code: "KRW", symbol: "₩", name: "South Korea" },
    "SS": { code: "SSP", symbol: "£", name: "South Sudan" },
    "ES": { code: "EUR", symbol: "€", name: "Spain" },
    "LK": { code: "LKR", symbol: "₨", name: "Sri Lanka" },
    "BL": { code: "EUR", symbol: "€", name: "St. Barthélemy" },
    "SH": { code: "SHP", symbol: "£", name: "St. Helena" },
    "KN": { code: "XCD", symbol: "$", name: "St. Kitts & Nevis" },
    "LC": { code: "XCD", symbol: "$", name: "St. Lucia" },
    "MF": { code: "EUR", symbol: "€", name: "St. Martin" },
    "PM": { code: "EUR", symbol: "€", name: "St. Pierre & Miquelon" },
    "VC": { code: "XCD", symbol: "$", name: "St. Vincent & Grenadines" },
    "SD": { code: "SDG", symbol: "ج.س.", name: "Sudan" },
    "SR": { code: "SRD", symbol: "$", name: "Suriname" },
    "SJ": { code: "NOK", symbol: "kr", name: "Svalbard & Jan Mayen" },
    "SE": { code: "SEK", symbol: "kr", name: "Sweden" },
    "CH": { code: "CHF", symbol: "CHF", name: "Switzerland" },
    "TW": { code: "TWD", symbol: "NT$", name: "Taiwan" },
    "TJ": { code: "TJS", symbol: "ЅМ", name: "Tajikistan" },
    "TZ": { code: "TZS", symbol: "Sh", name: "Tanzania" },
    "TH": { code: "THB", symbol: "฿", name: "Thailand" },
    "TL": { code: "USD", symbol: "$", name: "Timor-Leste" },
    "TG": { code: "XOF", symbol: "Fr", name: "Togo" },
    "TK": { code: "NZD", symbol: "$", name: "Tokelau" },
    "TO": { code: "TOP", symbol: "T$", name: "Tonga" },
    "TT": { code: "TTD", symbol: "$", name: "Trinidad & Tobago" },
    "TA": { code: "GBP", symbol: "£", name: "Tristan da Cunha" },
    "TN": { code: "TND", symbol: "د.ت", name: "Tunisia" },
    "TR": { code: "TRY", symbol: "₺", name: "Türkiye" },
    "TM": { code: "TMT", symbol: "m", name: "Turkmenistan" },
    "TC": { code: "USD", symbol: "$", name: "Turks & Caicos Islands" },
    "TV": { code: "AUD", symbol: "$", name: "Tuvalu" },
    "UM": { code: "USD", symbol: "$", name: "U.S. Outlying Islands" },
    "UG": { code: "UGX", symbol: "Sh", name: "Uganda" },
    "UA": { code: "UAH", symbol: "₴", name: "Ukraine" },
    "AE": { code: "AED", symbol: "د.إ", name: "United Arab Emirates" },
    "UY": { code: "UYU", symbol: "$U", name: "Uruguay" },
    "UZ": { code: "UZS", symbol: "сўм", name: "Uzbekistan" },
    "VU": { code: "VUV", symbol: "Vt", name: "Vanuatu" },
    "VA": { code: "EUR", symbol: "€", name: "Vatican City" },
    "VE": { code: "VES", symbol: "Bs.S.", name: "Venezuela" },
    "VN": { code: "VND", symbol: "₫", name: "Vietnam" },
    "WF": { code: "XPF", symbol: "Fr", name: "Wallis & Futuna" },
    "EH": { code: "MAD", symbol: "د.م.", name: "Western Sahara" },
    "YE": { code: "YER", symbol: "ر.ي", name: "Yemen" },
    "ZM": { code: "ZMW", symbol: "ZK", name: "Zambia" },
    "ZW": { code: "ZWG", symbol: "ZiG", name: "Zimbabwe" }
  };

  const PRICE_RE = /(?:Rs\.|₹|\$|£|€)\s*([\d,]+\.?\d*)/;
  let exchangeRates = null; // rates are relative to BASE once loaded

  function savedCountry() {
    return localStorage.getItem('selected-country') || 'IN';
  }

  // Live rates with BASE (the store's checkout currency) as the reference.
  fetch('https://open.er-api.com/v6/latest/' + BASE)
    .then(res => res.json())
    .then(data => {
      if (data && data.rates) {
        exchangeRates = data.rates;
        window.applyThemeCurrency(savedCountry());
      }
    })
    .catch(err => {
      console.warn('Could not fetch exchange rates; prices stay in ' + BASE + '.', err);
    });

  function formatCurrency(value, currencyCode, symbol) {
    const formattedNumber = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
    if (currencyCode === 'INR') {
      return 'Rs. ' + formattedNumber;
    }
    return symbol + ' ' + formattedNumber;
  }

  // Scan leaf elements for prices in the store's base currency and remember
  // the numeric value so conversion is always applied to the true base amount.
  function tagPrices() {
    document.querySelectorAll('body *').forEach(el => {
      if (el.children.length === 0 && el.textContent && !el.hasAttribute('data-base-price')) {
        if (el.closest('#CurrencyNoticeBar')) return; // the notice bar manages its own text
        const text = el.textContent.trim();
        const match = text.match(PRICE_RE);
        if (match) {
          const basePrice = parseFloat(match[1].replace(/,/g, ''));
          if (!isNaN(basePrice)) {
            el.setAttribute('data-base-price', basePrice);
            el.setAttribute('data-original-text', text);
          }
        }
      }
    });
  }

  // Cart disclosure bar: shows the regional estimate AND the real charge currency.
  function updateCartNotice(mapping) {
    const bar = document.getElementById('CurrencyNoticeBar');
    if (!bar) return;
    const total = parseFloat(bar.getAttribute('data-cart-total'));
    const baseSymbol = bar.getAttribute('data-base-symbol') || '$';
    const baseAmount = formatCurrency(total, BASE, baseSymbol);
    if (!mapping || mapping.code === BASE || !exchangeRates || !exchangeRates[mapping.code]) {
      bar.innerHTML = 'All orders are charged in <strong>' + BASE + ' (' + baseAmount + ')</strong> at checkout.';
      return;
    }
    const converted = formatCurrency(total * exchangeRates[mapping.code], mapping.code, mapping.symbol);
    bar.innerHTML = 'Region currency <strong>' + mapping.code + '</strong> &asymp; <strong>' + converted + '</strong> &middot; You will be charged in <strong>' + BASE + ' (' + baseAmount + ')</strong> at checkout.';
  }

  window.applyThemeCurrency = function(countryCode) {
    const mapping = countryToCurrency[countryCode] || { code: BASE, symbol: '', name: countryCode };
    const rate = exchangeRates ? exchangeRates[mapping.code] : null;
    const convertible = mapping.code !== BASE && rate;

    document.querySelectorAll('[data-base-price]').forEach(el => {
      const basePrice = parseFloat(el.getAttribute('data-base-price'));
      const originalText = el.getAttribute('data-original-text');
      if (!convertible) {
        el.textContent = originalText; // show real base-currency prices
        return;
      }
      const formattedPrice = formatCurrency(basePrice * rate, mapping.code, mapping.symbol);
      el.textContent = originalText.replace(PRICE_RE, formattedPrice);
    });

    // Header selector labels
    document.querySelectorAll('.disclosure__current-country, .disclosure__current-country-mobile').forEach(lbl => {
      lbl.textContent = mapping.name + ' | ' + mapping.code + ' ' + mapping.symbol;
    });

    // Active state in the dropdown lists
    document.querySelectorAll('.disclosure__link, .disclosure__link-mobile').forEach(link => {
      const active = link.getAttribute('data-value') === countryCode;
      link.style.backgroundColor = active ? 'var(--color-cream)' : '';
      link.style.fontWeight = active ? '600' : '';
    });

    updateCartNotice(mapping);
  };

  // Relabel dropdown entries with each country's real currency (Shopify renders
  // them all with the store currency because Markets only has one currency).
  document.querySelectorAll('.disclosure__link, .disclosure__link-mobile').forEach(link => {
    const mapping = countryToCurrency[link.getAttribute('data-value')];
    if (mapping) {
      const countryName = link.textContent.trim().split('|')[0].trim();
      link.textContent = countryName + ' | ' + mapping.code + ' ' + mapping.symbol;
    }
  });

  tagPrices();
  window.applyThemeCurrency(savedCountry());

  // Convert prices that arrive later (ajax cart, sliders, lazy sections).
  const observer = new MutationObserver(mutations => {
    const added = mutations.some(m => Array.from(m.addedNodes).some(n => n.nodeType === 1));
    if (!added) return;
    observer.disconnect();
    tagPrices();
    window.applyThemeCurrency(savedCountry());
    observer.observe(document.body, { childList: true, subtree: true });
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

// 5. Sticky Header Scroll Effect
function initStickyHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  const handleScroll = () => {
    if (window.scrollY > 30) {
      header.classList.add('site-header--scrolled');
    } else {
      header.classList.remove('site-header--scrolled');
    }
  };

  // Run on load and on scroll
  handleScroll();
  window.addEventListener('scroll', handleScroll);
}

// 6. Luxury Page Loader dismissal
function initLuxuryLoader() {
  const loader = document.getElementById('LuxuryLoader');
  if (!loader) return;

  // Dismiss loader on load
  window.addEventListener('load', function() {
    loader.classList.add('fade-out');
  });

  // Fallback: dismiss after 2.5 seconds if window load event doesn't fire or is slow
  setTimeout(() => {
    loader.classList.add('fade-out');
  }, 2500);
}

